import PropTypes from "prop-types";
import { generatePosterUrl } from "../CategoryHeaderVideo/generatePosterUrl";
import styles from "./index.css";

const CategoryHeaderImage = ({ viewportCategory, featuredHeaderData }) => (
  <div className={styles.categoryHeaderImage}>
    <img
      className={styles.image}
      src={generatePosterUrl(viewportCategory, featuredHeaderData)}
      alt=""
    />
  </div>
);

CategoryHeaderImage.propTypes = {
  viewportCategory: PropTypes.string.isRequired,
  featuredHeaderData: PropTypes.shape({
    app: PropTypes.shape({
      imageUrl: PropTypes.string,
      videoAssetId: PropTypes.string,
    }),
    displayText: PropTypes.string,
    isEnabled: PropTypes.bool,
    web: PropTypes.shape({
      imageUrl: PropTypes.string,
      videoAssetId: PropTypes.string,
    }),
  }),
};

export default CategoryHeaderImage;
